import { render, staticRenderFns } from "./CustomInputInt.vue?vue&type=template&id=2c6cf7e2&scoped=true&"
import script from "./CustomInputInt.vue?vue&type=script&lang=js&"
export * from "./CustomInputInt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6cf7e2",
  null
  
)

export default component.exports